/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ClientSurveyVersionModel } from '../models/client-survey-version-model';
import { createSurveyVersion$Json } from '../fn/survey-version/create-survey-version-json';
import { CreateSurveyVersion$Json$Params } from '../fn/survey-version/create-survey-version-json';
import { createSurveyVersion$Plain } from '../fn/survey-version/create-survey-version-plain';
import { CreateSurveyVersion$Plain$Params } from '../fn/survey-version/create-survey-version-plain';
import { deleteSurveyVersionAsync$Json } from '../fn/survey-version/delete-survey-version-async-json';
import { DeleteSurveyVersionAsync$Json$Params } from '../fn/survey-version/delete-survey-version-async-json';
import { deleteSurveyVersionAsync$Plain } from '../fn/survey-version/delete-survey-version-async-plain';
import { DeleteSurveyVersionAsync$Plain$Params } from '../fn/survey-version/delete-survey-version-async-plain';
import { deleteSurveyVersionsAsync$Json } from '../fn/survey-version/delete-survey-versions-async-json';
import { DeleteSurveyVersionsAsync$Json$Params } from '../fn/survey-version/delete-survey-versions-async-json';
import { deleteSurveyVersionsAsync$Plain } from '../fn/survey-version/delete-survey-versions-async-plain';
import { DeleteSurveyVersionsAsync$Plain$Params } from '../fn/survey-version/delete-survey-versions-async-plain';
import { getSurveyVersionById$Json } from '../fn/survey-version/get-survey-version-by-id-json';
import { GetSurveyVersionById$Json$Params } from '../fn/survey-version/get-survey-version-by-id-json';
import { getSurveyVersionById$Plain } from '../fn/survey-version/get-survey-version-by-id-plain';
import { GetSurveyVersionById$Plain$Params } from '../fn/survey-version/get-survey-version-by-id-plain';
import { updateSurveyVersionAsync$Json } from '../fn/survey-version/update-survey-version-async-json';
import { UpdateSurveyVersionAsync$Json$Params } from '../fn/survey-version/update-survey-version-async-json';
import { updateSurveyVersionAsync$Plain } from '../fn/survey-version/update-survey-version-async-plain';
import { UpdateSurveyVersionAsync$Plain$Params } from '../fn/survey-version/update-survey-version-async-plain';

@Injectable({ providedIn: 'root' })
export class SurveyVersionService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getSurveyVersionById()` */
  static readonly GetSurveyVersionByIdPath = '/api/SurveyVersion/{surveyVersionId}';

  /**
   * get surveyversion by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSurveyVersionById$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyVersionById$Plain$Response(params: GetSurveyVersionById$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyVersionModel>> {
    return getSurveyVersionById$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * get surveyversion by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSurveyVersionById$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyVersionById$Plain(params: GetSurveyVersionById$Plain$Params, context?: HttpContext): Observable<ClientSurveyVersionModel> {
    return this.getSurveyVersionById$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientSurveyVersionModel>): ClientSurveyVersionModel => r.body)
    );
  }

  /**
   * get surveyversion by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSurveyVersionById$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyVersionById$Json$Response(params: GetSurveyVersionById$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyVersionModel>> {
    return getSurveyVersionById$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * get surveyversion by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSurveyVersionById$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyVersionById$Json(params: GetSurveyVersionById$Json$Params, context?: HttpContext): Observable<ClientSurveyVersionModel> {
    return this.getSurveyVersionById$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientSurveyVersionModel>): ClientSurveyVersionModel => r.body)
    );
  }

  /** Path part for operation `updateSurveyVersionAsync()` */
  static readonly UpdateSurveyVersionAsyncPath = '/api/SurveyVersion/{surveyVersionId}';

  /**
   * update surveyversion by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSurveyVersionAsync$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateSurveyVersionAsync$Plain$Response(params: UpdateSurveyVersionAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyVersionModel>> {
    return updateSurveyVersionAsync$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * update surveyversion by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSurveyVersionAsync$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateSurveyVersionAsync$Plain(params: UpdateSurveyVersionAsync$Plain$Params, context?: HttpContext): Observable<ClientSurveyVersionModel> {
    return this.updateSurveyVersionAsync$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientSurveyVersionModel>): ClientSurveyVersionModel => r.body)
    );
  }

  /**
   * update surveyversion by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSurveyVersionAsync$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateSurveyVersionAsync$Json$Response(params: UpdateSurveyVersionAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyVersionModel>> {
    return updateSurveyVersionAsync$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * update surveyversion by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSurveyVersionAsync$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateSurveyVersionAsync$Json(params: UpdateSurveyVersionAsync$Json$Params, context?: HttpContext): Observable<ClientSurveyVersionModel> {
    return this.updateSurveyVersionAsync$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientSurveyVersionModel>): ClientSurveyVersionModel => r.body)
    );
  }

  /** Path part for operation `deleteSurveyVersionAsync()` */
  static readonly DeleteSurveyVersionAsyncPath = '/api/SurveyVersion/{surveyVersionId}';

  /**
   * delete surveyversion by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteSurveyVersionAsync$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSurveyVersionAsync$Plain$Response(params: DeleteSurveyVersionAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    return deleteSurveyVersionAsync$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * delete surveyversion by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteSurveyVersionAsync$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSurveyVersionAsync$Plain(params: DeleteSurveyVersionAsync$Plain$Params, context?: HttpContext): Observable<number> {
    return this.deleteSurveyVersionAsync$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /**
   * delete surveyversion by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteSurveyVersionAsync$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSurveyVersionAsync$Json$Response(params: DeleteSurveyVersionAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    return deleteSurveyVersionAsync$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * delete surveyversion by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteSurveyVersionAsync$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSurveyVersionAsync$Json(params: DeleteSurveyVersionAsync$Json$Params, context?: HttpContext): Observable<number> {
    return this.deleteSurveyVersionAsync$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /** Path part for operation `createSurveyVersion()` */
  static readonly CreateSurveyVersionPath = '/api/SurveyVersion';

  /**
   * create new surveyversion.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createSurveyVersion$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createSurveyVersion$Plain$Response(params?: CreateSurveyVersion$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyVersionModel>> {
    return createSurveyVersion$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * create new surveyversion.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createSurveyVersion$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createSurveyVersion$Plain(params?: CreateSurveyVersion$Plain$Params, context?: HttpContext): Observable<ClientSurveyVersionModel> {
    return this.createSurveyVersion$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientSurveyVersionModel>): ClientSurveyVersionModel => r.body)
    );
  }

  /**
   * create new surveyversion.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createSurveyVersion$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createSurveyVersion$Json$Response(params?: CreateSurveyVersion$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyVersionModel>> {
    return createSurveyVersion$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * create new surveyversion.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createSurveyVersion$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createSurveyVersion$Json(params?: CreateSurveyVersion$Json$Params, context?: HttpContext): Observable<ClientSurveyVersionModel> {
    return this.createSurveyVersion$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientSurveyVersionModel>): ClientSurveyVersionModel => r.body)
    );
  }

  /** Path part for operation `deleteSurveyVersionsAsync()` */
  static readonly DeleteSurveyVersionsAsyncPath = '/api/SurveyVersion';

  /**
   * delete multiple surveyversion by survey id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteSurveyVersionsAsync$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSurveyVersionsAsync$Plain$Response(params: DeleteSurveyVersionsAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    return deleteSurveyVersionsAsync$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * delete multiple surveyversion by survey id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteSurveyVersionsAsync$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSurveyVersionsAsync$Plain(params: DeleteSurveyVersionsAsync$Plain$Params, context?: HttpContext): Observable<number> {
    return this.deleteSurveyVersionsAsync$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /**
   * delete multiple surveyversion by survey id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteSurveyVersionsAsync$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSurveyVersionsAsync$Json$Response(params: DeleteSurveyVersionsAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    return deleteSurveyVersionsAsync$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * delete multiple surveyversion by survey id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteSurveyVersionsAsync$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSurveyVersionsAsync$Json(params: DeleteSurveyVersionsAsync$Json$Params, context?: HttpContext): Observable<number> {
    return this.deleteSurveyVersionsAsync$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

}
